import { axiosInstance } from "../../../axios/axiosInstance";
import { LANDING_API_URL, getDefaultHeaders } from "../../../config";

const authHeaders = () => {
  const authToken = localStorage.getItem("authToken");
  return {
    ...getDefaultHeaders(),
    Authorization: `Bearer ${authToken}`,
  };
};

export const getCustomPages = () =>
  axiosInstance.get(`${LANDING_API_URL}/master-pages`, {
    headers: authHeaders(),
  });

export const createCustomPageRequest = (pageData) =>
  axiosInstance.post(`${LANDING_API_URL}/master-pages`, pageData, {
    headers: authHeaders(),
  });

export const updateCustomPageRequest = (id, pageData) =>
  axiosInstance.post(`${LANDING_API_URL}/master-pages/${id}`, pageData, {
    headers: authHeaders(),
  });

export const removeCustomPage = (pageId) =>
  axiosInstance.delete(`${LANDING_API_URL}/master-pages/${pageId}`, {
    headers: authHeaders(),
  });
